import { createApi, fetchData, deleteApi, getApi, updateApi, uploadApi } from '@/lib/api.service.js'

const currentUrl = `${import.meta.env.VITE_BACKEND_URL}/api/v2/servicechek/countries`;

export async function indexCountries(params = null) {
  try {
    return await fetchData(currentUrl, params);
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function getCountry(id){
  try {
    let url = `${currentUrl}/${id}`;
    const response = await getApi(url);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function createCountry(data) {
  data = { country: data };

  try {
    const response = await createApi(currentUrl, data);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function updateCountry(id, data) {
  data = { country: data };

  try {
    let url = `${currentUrl}/${id}`;
    const response = await updateApi(url, data);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}